<div class="bb-beneficiary-selector-ui"
  ngbDropdown
  #dd="ngbDropdown"
  display="static"
  (openChange)="handleDropdownClose($event, dd)">
  <label *ngIf="title"
    [for]="searchElem?.id">{{ title }}</label>

  <span class="bb-dynamic-input__helper-text bb-text-support"
    *ngIf="helperText"
    [id]="searchElem?.id + '__helper-text'"
    [textContent]="helperText">
  </span>

  <bb-search-box-ui ngbDropdownAnchor
    (focus)="focusHandler()"
    (blur)="onBlur()"
    [formControl]="search"
    (clear)="onClear()"
    data-role="beneficiary-account-input"
    (ngModelChange)="handleSearch(search.value)"
    [placeholder]="placeholder"
    [squareBorder]="true"
    [showClear]="!isBeneficiaryDisabled"
    [autocomplete]="'off'"
    [disabled]="isBeneficiaryDisabled || disabled"
    [readonly]="readOnly"
    role="combobox"
    aria-haspopup="true"
    class="search-box-payments"
    [attr.aria-owns]="tabsComponent.tabsId"
    #searchElem>
    <button bbButton
      ngbDropdownToggle
      class="bn-beneficiary-selector-toggle"
      color="outline-secondary"
      [attr.aria-label]="ariaLabel"
      data-role="open-beneficiary-dropdown-list-button">
      <bb-icon-ui [name]="dropdownIcon"></bb-icon-ui>
    </button>
  </bb-search-box-ui>

  <div ngbDropdownMenu
    class="dropdown-menu dropdown-menu-right w-100 bb-beneficiary-selector-ui__list">
    <div class="bb-block bb-block--lg px-3">
      <bb-search-box-ui ngbDropdownAnchor
        (focus)="focusHandler()"
        (blur)="onBlur()"
        [showSearch]="true"
        [placeholder]="searchLabel"
        [formControl]="search"
        (clear)="onClear()"
        [autocomplete]="'off'"
        [showClear]="!isBeneficiaryDisabled"
        (ngModelChange)="handleSearch(search.value)"
        [aria-labelledby]="'ariaLabelledby'"
        [aria-describedby]="'ariaDescribedby'"
        #searchElemIn></bb-search-box-ui>
    </div>

    <bn-beneficiary-tabs #tabsComponent
      class="bb-beneficiary-selector-ui__tabs"
      [accounts]="accounts"
      [contacts]="contacts"
      [catalogues]="catalogues"
      [listState]="state"
      [tabsConfig]="tabs"
      [totalAccounts]="totalAccounts"
      [totalContacts]="totalContacts"
      [totalCatalogues]="totalCatalogues"
      [canEditManually]="false"
      [isDropdownOpen]="dd.isOpen()"
      (selectedContact)="selectContact($event); dd.close()"
      (selectedAccount)="selectAccount($event); dd.close()"
      (selectedCatalog)="selectCatalog($event); dd.close()"
      (fetchMoreItems)="fetchMoreItemsAction($event)"
      (manualEdit)="onManualEdit(); dd.close()">
    </bn-beneficiary-tabs>
  </div>
</div>
